import React from 'react';

import { cn } from 'helpers/classnames';
import { PROVIDE_LABEL_OPTIONS } from 'constants/exchanges';
import Timeline from 'components/account/Returns/Timeline';
import useMartyContext from 'hooks/useMartyContext';

// eslint-disable-next-line css-modules/no-unused-class
import css from 'styles/components/account/returns/returnRefundInfo.scss';

const { TimelineItem } = Timeline;

const standardText = [
  <>Submit return request.</>,
  <>Drop off your return item(s) at an eligible location.</>,
  <>
    <strong>FAST REFUNDS:</strong> For eligible orders, your refund will be issued once dropped off and scanned by the return carrier.
  </>,
  <>
    Eligible refunds are issued immediately. Please allow up to 24 hours for store credit. Some financial institutions may take up to 10 business
    days. Afterpay may take up to 20 business days and PayPal up to 30 business days.
  </>,
  <>Refunds for some customers can take up to 30 days.</>,
  <>Guest checkout customer refunds will only be issued to original form of payment.</>,
  <>Afterpay refunds will be issued only up to the amount paid at the time of return.</>,
  <>
    If items for which you were issued a refund have not been received by Zappos, a warning email will be sent at 30 days as a reminder of the
    potential charge. After 45 days, a charge for the items not returned may be applied to the original form of payment.
  </>
];

const ReturnRefundInfo = ({ showReturnInstructionsBoxes, labelDelivery }) => {
  const {
    marketplace: { is6pm }
  } = useMartyContext();

  if (labelDelivery === PROVIDE_LABEL_OPTIONS.MAIL || is6pm) {
    return null;
  }

  return (
    <section className={cn(css.firstScan, { [css.firstScanWithMargin]: showReturnInstructionsBoxes })}>
      <h2 className="zappos:heading-s">When You'll Receive Your Refund</h2>
      <Timeline>
        {standardText.map((text, index) => (
          <TimelineItem color="gray" key={index}>
            {text}
          </TimelineItem>
        ))}
      </Timeline>
    </section>
  );
};

export default ReturnRefundInfo;
